<template>
    <div>
        <!-- Spinner de chargement -->
        <div v-if="recording">
            <b-row class="mt-5 text-center">
                <b-col>
                    <b-spinner label="spinning"></b-spinner> <span class="h3">Enregistrement en cours</span>
                </b-col>
            </b-row>
        </div>
        <div v-else-if="statusOk">
            <h4>Votre inscription à bien été enregistré !</h4>

            <b-alert show variant="info" class="my-3">
                <h5><b-icon icon="check2" aria-hidden="true"></b-icon> Votre numéro de dossier CNAREFE est le <strong>{{ numCnarefe }}</strong></h5>
            </b-alert>

            <p>Un message de confirmation vous a été envoyé à l'adresse email que vous avez indiqué. Par mesure de sécurité, ce dernier ne contient aucune des informations précédemment saisies.</p>

            <p>Nous vous invitons à télécharger le récapitulatif de votre demande en cliquant sur le bouton ci-dessous.</p>

            <div class="text-center my-5">
                <b-button
                    size="lg"
                    variant="primary"
                    :href="'data:application/pdf;base64,' + pdf"
                    :download="fileName"
                    target="_blank">
                    <b-icon icon="file-earmark-arrow-down" aria-hidden="true"></b-icon> Télécharger le récapitulatif
                </b-button>
            </div>

            <div class="text-center mb-5">
                <b-button
                    v-b-modal.modal-qac
                    size="lg"
                    variant="info"
                    target="_blank"
                    :disabled="disabledBtnModalQac">
                    <b-icon icon="emoji-heart-eyes" aria-hidden="true"></b-icon> {{ libelleBtnModalQac }}
                </b-button>

                <b-modal id="modal-qac" size="lg" title="Votre avis est important" @ok="enregistrerQac()" @hidden="resetModal()" ok-only ok-title="Enregistrer" :ok-disabled="okDisabledModal">

                    <b-row class="ml-3">
                        <b-col cols="9">
                            <div>
                                <b-icon icon="arrow-right-circle"></b-icon>
                                Avez-vous rencontré des difficultés pour réaliser votre inscription ?    
                            </div>
                        </b-col>
                        <b-col cols="3" class="text-right" align-self="center">
                            <b-form-radio-group
                                id="difficultesInscription"
                                name="difficultesInscription"
                                v-model="difficultesInscription"
                                :options="optionsOuiNon"
                            ></b-form-radio-group>
                        </b-col>
                    </b-row>
                    <b-row v-show="showDetailDifficultesInscription" class="ml-3 mt-2">
                        <b-col cols="12">
                            <div>
                                <b-form-input v-model="detailDifficultesInscription" placeholder="Quelles étaient ces difficultés ?" maxlength="1000"></b-form-input>       
                            </div>
                        </b-col>
                    </b-row>                    

                    <b-row class="ml-3 mt-4">
                        <b-col cols="9">
                            <div>
                                <b-icon icon="arrow-right-circle"></b-icon>
                                Avez-vous consulté la FAQ ?    
                            </div>
                        </b-col>
                        <b-col cols="3" class="text-right" align-self="center">
                            <b-form-radio-group
                                id="consultationFaq"
                                name="consultationFaq"
                                v-model="consultationFaq"
                                :options="optionsOuiNon"
                            ></b-form-radio-group>
                        </b-col>
                    </b-row>
                    <b-row v-show="showQuestionFaqInfoUtiles" class="ml-3 mt-2">
                        <b-col cols="9">
                            <div class="ml-5">
                                - Y avez-vous trouvé les informations nécessaires ?    
                            </div>
                        </b-col>
                        <b-col cols="3" class="text-right" align-self="center">
                            <b-form-radio-group
                                id="btn-pension4"
                                name="pension4"
                                v-model="faqInfoUtiles"
                                :options="optionsOuiNon"
                            ></b-form-radio-group>
                        </b-col>
                    </b-row>
                    <b-row v-show="showDetailFaqInfoUtiles" class="ml-3 mt-2">
                        <b-col cols="12">
                            <div>
                                <b-form-input v-model="detailFaqInfoUtiles" placeholder="Que recherchiez-vous ?" maxlength="1000"></b-form-input>       
                            </div>
                        </b-col>
                    </b-row>                    

                    <b-row class="ml-3 mt-4">
                        <b-col cols="12">
                            <div>
                                <b-icon icon="arrow-right-circle"></b-icon>
                                Comment avez-vous eu connaissance du dispositif CNAREFE ?    
                            </div>
                        </b-col>
                    </b-row>

                    <b-row class="ml-3 mt-2">
                        <b-col cols="12">
                            <div>
                                <b-form-select v-model="connaissanceCnarefe" :options="optionsConnaissanceCnarefe"></b-form-select>       
                            </div>
                        </b-col>
                    </b-row>
                    <b-row v-show="showDetailConnaissanceCnarefe" class="ml-3 mt-3">
                        <b-col cols="12">
                            <div>
                                <b-form-input v-model="detailConnaissanceCnarefe" placeholder="Pouvez-vous préciser ?" maxlength="1000"></b-form-input>       
                            </div>
                        </b-col>
                    </b-row>

                    <b-row class="ml-3 mt-4">
                        <b-col cols="12">
                            <div>
                                <b-icon icon="arrow-right-circle"></b-icon>
                                D'une manière générale, êtes-vous plutôt ?    
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="ml-3 mt-3">
                        <b-col cols="12">
                            <b-icon
                                v-for="mood in optionsSatisfaction"
                                :key="mood.value"
                                :icon="mood.icon"
                                :variant="mood.variant"
                                font-scale="4"
                                class="mood-icon"
                                :class="{ selected: satisfaction === mood.value }"
                                @click="satisfaction = mood.value"
                            />
                        </b-col>
                    </b-row>
                    <b-row v-show="showDetailSatisfaction" class="ml-3 mt-3">
                        <b-col cols="12">
                            <div>
                                <b-form-input v-model="detailSatisfaction" placeholder="Quelles améliorations aimeriez-vous voir ?" maxlength="1000"></b-form-input>       
                            </div>
                        </b-col>
                    </b-row>

                </b-modal>
            </div>            

            <p>Toute l'équipe du CNAREFE vous souhaite une agréable journée.</p>
        </div>
        <div v-else>
            <b-alert show variant="danger">
                <b-row align-v="center">
                    <b-col cols="auto">
                        <b-icon icon="x-circle" scale="1.5"></b-icon>
                    </b-col>
                    <b-col>
                        <h5>Quelque chose s'est mal passé désolé :(</h5>
                        L'enregistrement de votre dossier semble avoir échoué. Veuillez recommencer votre demande d'inscription dans quelques minutes.
                    </b-col>
                </b-row>
            </b-alert>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Enregistrement',
    data () {
        return {
            recording: true,
            statusOk: false,
            numCnarefe: null,
            fileName: null,
            pdf: null,

            // Etat disabled du bouton pour ouvrir la modal du QAC
            disabledBtnModalQac: false,
            libelleBtnModalQac: 'Nous aimerions avoir votre avis...',

            optionsOuiNon: [
                { text: 'Oui', value: 'oui' },
                { text: 'Non', value: 'non' }
            ],

            difficultesInscription: null,
            showDetailDifficultesInscription: false,
            detailDifficultesInscription: null,
            //
            consultationFaq: null,
            showQuestionFaqInfoUtiles: false,
            faqInfoUtiles: null,
            showDetailFaqInfoUtiles: false,
            detailFaqInfoUtiles: null,
            //      
            connaissanceCnarefe: null,
            optionsConnaissanceCnarefe: [
                { value: null, text: 'Choisir dans la liste...' },
                { text: 'CNAV', value: 'cnav' },
                { text: 'CPAM/3646', value: 'cpam' },
                { text: 'Ameli.fr', value: 'ameli' },
                { text: 'Site du Cleiss', value: 'cleiss' },
                { text: 'Parents/Amis/Proches', value: 'parents' },
                { text: 'Autre', value: 'autre' }
            ],
            showDetailConnaissanceCnarefe: false,
            detailConnaissanceCnarefe: null,

            satisfaction: null,
            optionsSatisfaction: [
                { value: 'satisfait', icon: 'emoji-heart-eyes', variant: 'success' },
                { value: 'neutre', icon: 'emoji-neutral', variant: 'warning' },
                { value: 'insatisfait', icon: 'emoji-frown', variant: 'danger' }
            ],
            showDetailSatisfaction: false,
            detailSatisfaction: null,
            
            okDisabledModal: true

        }
    },
    mounted() {

        // Renvoi vers l'URL du site
        if (!this.$actions.getStepChecked('accueil') || !this.$actions.getStepChecked('identite') || !this.$actions.getStepChecked('coordonnees') || !this.$actions.getStepChecked('regulariteDeSejour') || !this.$actions.getStepChecked('piecesAJoindre') || !this.$actions.getStepChecked('validation')) {
            this.$actions.router('Init');
        }

        // Envoi un évenement onSetStepper pour mettre a jour l'étape
        this.$emit('onSetStepper', null);

        const config = {
            headers: {
                'Authorization': this.$store.token
            }
        }

        // Prépare un objet de data a envoyer pour l'enregistrement des données
        const data = {
            // Identite.vue
            nomNaissance: this.$store.nomNaissance,
            nomUsage: this.$store.nomUsage,
            prenom: this.$store.prenom,
            dateNaissance: this.$store.dateNaissance,
            lieuNaissance: this.$store.lieuNaissance,
            nni: this.$store.nni,
            cleNni: this.$store.cleNni,
            nationalite: this.$store.nationalite,
            carteVitale: this.$store.carteVitale,

            // Coordonnees.vue
            adresseEtranger: this.$store.adresseEtranger,
            paysResidence: this.$store.paysResidence.codePays,
            provinceCanada: this.$store.provinceCanada,
            quinzeAnneesCotisations: this.$store.quinzeAnneesCotisations,
            nationaliteFrCa: this.$store.nationaliteFrCa,
            pensionMultiOrigines: this.$store.pensionMultiOrigines,
            email: this.$store.email,
            adresseTempoFrance: this.$store.adresseTempoFrance,
            nomHoteAdresseFrance: this.$store.nomHoteAdresseFrance,
            adresseFrance: this.$store.adresseFrance,
            communeFrance: this.$store.communeFrance,

            // RegulariteDeSejour.vue
            titreAutreVisaSchengen: this.$store.titreAutreVisaSchengen,
            visaSchengen: this.$store.visaSchengen,
            passeportAutorisantSejour: this.$store.passeportAutorisantSejour,
            possessionTitreSejour: this.$store.possessionTitreSejour,

            // Validation.vue
            ouvertureCompteAmeli: this.$store.ouvertureCompteAmeli,
            acceptationReglesUtilisation: this.$store.acceptationReglesUtilisation,
            adhesionAssuranceMaladieRegimeGeneral: this.$store.adhesionAssuranceMaladieRegimeGeneral,
            captchaResponse: this.$store.captchaResponse
        }

        // Enregistrement des données contenues dans le $store
        this.$axios
            .post(this.$config.API + '/enregistrer-inscription',
            data,
            config).then(
                response => {
                    setTimeout(() => {
                        //console.log(response.data)
                        this.recording = false
                        this.$store.endOfInscription = true
                        if (response.data.status == 1) {
                            this.numCnarefe = response.data.data.numCnarefe
                            this.fileName = response.data.data.fileName
                            this.pdf = response.data.data.pdf
                            this.statusOk = true;
                        } else {
                            throw response.data.message;
                        }
                    }, 1500)
                }
            ).catch(error => {
                this.recording = false
                this.$store.endOfInscription = true
                console.log(error);
            })
    },

    methods: {
        resetModal() {
            this.difficultesInscription = null,
            this.showDetailDifficultesInscription = false,
            this.detailDifficultesInscription = null,

            this.consultationFaq = null,
            this.showQuestionFaqInfoUtiles = false,
            this.faqInfoUtiles = null

            this.faqInfoUtiles = null,
            this.showDetailFaqInfoUtiles = false,
            this.detailFaqInfoUtiles = null

            this.connaissanceCnarefe = null,
            this.showDetailConnaissanceCnarefe = false,
            this.detailConnaissanceCnarefe = null,

            this.satisfaction = null,
            this.showDetailSatisfaction = false,
            this.detailSatisfaction = null,

            this.okDisabledModal = true
        },

        setOkDisabledModal() {
            this.okDisabledModal = (
                this.difficultesInscription ||
                this.consultationFaq ||
                this.connaissanceCnarefe ||    
                this.satisfaction  
            ) ? false : true
        },

        enregistrerQac() {
            // Prépare un objet de data avec les réponse du qac à enregistrer
            const data = {
                numCnarefe: this.numCnarefe,

                difficultesInscription: this.difficultesInscription,
                detailDifficultesInscription: this.detailDifficultesInscription,

                consultationFaq: this.consultationFaq,
                faqInfoUtiles: this.faqInfoUtiles,
                detailFaqInfoUtiles: this.detailFaqInfoUtiles,

                connaissanceCnarefe: this.connaissanceCnarefe,
                detailConnaissanceCnarefe: this.detailConnaissanceCnarefe,

                satisfaction: this.satisfaction,
                detailSatisfaction: this.detailSatisfaction
            }

            const config = {
                headers: {
                    'Authorization': this.$store.token
                }
            }

            // Enregistrement du questionnaire à chaud
            this.$axios.post(this.$config.API + '/enregistrer-qac',
            data,
            config).then(
                response => {
                    if (response.data.status == 1) {
                        console.log("Votre avis a bien été enregistré.");    
                    } else {
                        throw response.data.message;
                    }
                }
            ).catch(error => {
                console.log(error);
            })

            // console.log(data)
            this.disabledBtnModalQac = true 
            this.libelleBtnModalQac = 'Merci !';
        }
    },

    watch: {
        difficultesInscription: function() {
            if (this.difficultesInscription == 'oui') {
                this.showDetailDifficultesInscription = true   
            } else {
                this.showDetailDifficultesInscription = false
                this.detailDifficultesInscription = null 
            }

            this.setOkDisabledModal()
        },
        consultationFaq: function() {
            if (this.consultationFaq == 'oui') {
                this.showQuestionFaqInfoUtiles = true   
            } else {
                this.showQuestionFaqInfoUtiles = false
                this.faqInfoUtiles = null 
            }

            this.setOkDisabledModal()
        },
        faqInfoUtiles: function() {
            if (this.faqInfoUtiles == 'non') {
                this.showDetailFaqInfoUtiles = true   
            } else {
                this.showDetailFaqInfoUtiles = false
                this.detailFaqInfoUtiles = null 
            }
        },
        connaissanceCnarefe: function() {
            if (this.connaissanceCnarefe == 'autre') {
                this.showDetailConnaissanceCnarefe = true   
            } else {
                this.showDetailConnaissanceCnarefe = false
                this.detailConnaissanceCnarefe = null 
            }

            this.setOkDisabledModal()
        },
        satisfaction: function() {
            if (this.satisfaction && this.satisfaction != 'satisfait') {
                this.showDetailSatisfaction = true   
            } else {
                this.showDetailSatisfaction = false
                this.detailSatisfaction = null 
            }

            this.setOkDisabledModal()
        }

    }
}
</script>

<style scoped>

.mood-icon {
  cursor: pointer;
  margin-right: 15px;
  transition: all 0.2s ease;
}

.mood-icon:hover {
  transform: scale(1.1);
}

.mood-icon.selected {
  transform: scale(1.2);
  filter: drop-shadow(0 0 8px rgba(0,0,0,0.3));
}

</style>



// WEBPACK FOOTER //
// src/components/Enregistrement.vue